/**
 * Lightweight correlation ids for Flow Inspector (no ALS).
 * BookingBus sets flowSpanId around seat tap / Continuar; HTTP reads current span.
 */

let currentFlowSpanId = null
let seq = 0

function uuidLike () {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID()
    }
  } catch {
    // ignore
  }
  seq += 1
  return `fr-${Date.now().toString(36)}-${seq.toString(36)}-${Math.random().toString(36).slice(2, 10)}`
}

export function newRequestId () {
  return uuidLike()
}

export function newFlowSpanId (kind = 'seat') {
  return `${kind}-${uuidLike()}`
}

export function getCurrentFlowSpanId () {
  return currentFlowSpanId
}

/**
 * @param {string|null|undefined} id
 */
export function setCurrentFlowSpanId (id) {
  currentFlowSpanId = id != null && id !== '' ? String(id) : null
  return currentFlowSpanId
}

/**
 * Begin a span and make it current.
 * @param {string} [kind]
 * @returns {string}
 */
export function beginFlowSpan (kind = 'seat') {
  const id = newFlowSpanId(kind)
  currentFlowSpanId = id
  return id
}

/**
 * Clear current span only if it still matches.
 * @param {string} [id]
 */
export function endFlowSpan (id) {
  if (id == null || currentFlowSpanId === id) {
    currentFlowSpanId = null
  }
}
